import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import {
  webSurveyAccountConsentLinkSx,
  webSurveyAccountConsentRowSx,
  webSurveyAccountConsentTextSx,
} from '../styles/webSurveyAccountStyles'

interface WebSurveyAccountConsentProps {
  readonly accepted: boolean
  readonly termsHref: string
  readonly privacyHref: string
  readonly onAcceptedChange: (accepted: boolean) => void
  readonly onStartConsentFlow: () => void
}

export function WebSurveyAccountConsent({
  accepted,
  termsHref,
  privacyHref,
  onAcceptedChange,
  onStartConsentFlow,
}: WebSurveyAccountConsentProps) {
  return (
    <Box sx={webSurveyAccountConsentRowSx} data-testid="web-survey-legal-consent-row">
      <Checkbox
        checked={accepted}
        onChange={(_, checked) => {
          if (checked) {
            onStartConsentFlow()
            return
          }
          onAcceptedChange(false)
        }}
        inputProps={{ 'aria-label': 'I agree to the Terms of Use and Privacy Policy' }}
        data-testid="web-survey-legal-consent"
        sx={{ mt: '4px', p: '5px' }}
      />
      <Typography component="p" sx={webSurveyAccountConsentTextSx}>
        I agree to the{' '}
        <Link
          href={termsHref}
          target="_blank"
          rel="noopener noreferrer"
          sx={webSurveyAccountConsentLinkSx}
          data-testid="web-survey-terms-link"
        >
          Terms of Use
        </Link>
        {' and '}
        <Link
          href={privacyHref}
          target="_blank"
          rel="noopener noreferrer"
          sx={webSurveyAccountConsentLinkSx}
          data-testid="web-survey-privacy-link"
        >
          Privacy Policy
        </Link>
      </Typography>
    </Box>
  )
}
